import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./main.css"; // Tailwind CSS import
import "./styles/globalStyles.css"; // Global unified UI styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
